import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import type { RootState } from './reducers';
import type { AppDispatch } from './types';

/**
 * useAppDispatch: a typesafe version of useDispatch
 * always use this hook instead of useDispatch
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * useAppSelector: a typesafe version of useSelector
 * always use this hook instead of useDispatch
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
